<template>
  <van-col style="width: 100%; background-color: #F0F4FF;">
    <div class="fixed-header">
      <div class="enterprise-title">
        <div class="back-icon" @click="goBack">
          <span class="back-arrow"></span>
        </div>
        <div class="enterprise-text">企业管理</div>
      </div>

      <div class="search-wrapper" :class="{ 'no-staff-filter': duty !== 3 && duty !== 99 }">
        <van-search v-model="searchValue" shape="round" @search="onSearch" @input="handleInput" placeholder="请输入企业名称" background="transparent"/>
      </div>

      <!-- 人员筛选下拉菜单（仅管理员可见） -->
      <div v-if="duty === 3 || duty === 99" class="staff-search-wrapper">
        <div class="staff-select" @click="showStaffPopup = true">
          <span>{{ getSelectedStaffText }}</span>
          <van-icon name="arrow-down" size="16px" color="#999" />
        </div>
        <van-popup v-model="showStaffPopup" position="bottom" round class="staff-popup">
          <div class="popup-header">
            <h3>选择人员</h3>
            <van-icon name="cross" size="20px" @click="showStaffPopup = false" />
          </div>
          <div class="popup-list">
            <div v-for="item in staffOptions" :key="item.id" class="popup-item" @click="selectStaff(item)">
              <span class="popup-item-text">{{ item.name }}</span>
              <van-icon name="arrow" size="16px" color="#999" />
            </div>
            <div v-if="staffOptions.length === 0" class="popup-empty">暂无人员数据</div>
          </div>
        </van-popup>
      </div>
    </div>

    <div class="content-wrapper" :class="{ 'with-staff-filter': duty === 3 || duty === 99 }">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="margin-bottom: 80px;">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check=false>
        <template #default>
          <div v-for="(item, index) in enterpriseList" :key="'enterprise-' + index" class="enterprise-card" @click="handleItem(item)">
            <div class="enterprise-card-content">
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">企业名称</div>
                <div class="enterprise-card-value">{{ item.enterpriseName }}</div>
              </div>
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">客户手机</div>
                <div class="enterprise-card-value">{{ item.customerPhone || '-' }}</div>
              </div>
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">跟进人</div>
                <div class="enterprise-card-value">{{ item.employeeName || '-' }}</div>
              </div>
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">备注</div>
                <div class="enterprise-card-value">{{ item.remark || '-' }}</div>
              </div>
            </div>
            <div class="enterprise-card-action">
              <van-icon name="edit" color="#176FCA" @click.stop="onEdit(item)" :disabled="isOperating" />
            </div>
          </div>

          <!-- 空状态 -->
          <div v-if="enterpriseList.length === 0 && !loading" class="empty-state">
            <van-icon name="search" size="64px" color="#c8c9cc" />
            <p class="empty-text">暂无企业数据</p>
          </div>
        </template>
      </van-list>
    </van-pull-refresh>
    </div>

    <!-- 按钮行 -->
    <div class="button-row">
      <van-button type="info" round block @click="showAddDialogFunc" :loading="isOperating" class="btn-get-sub" icon="plus">
      添加
    </van-button>
      <div 
        class="home-button" 
        @click="goToHome"
      >
        <van-icon name="wap-home" size="14" />
      </div>
    </div>

    <!-- 删除确认对话框 -->
    <van-dialog v-model="showDeleteDialog" title="确认删除" message="确定要删除这个企业吗？" show-cancel-button
      @confirm="confirmDelete" :confirm-button-loading="isOperating" />

    <!-- 企业编辑对话框（添加/修改） -->
    <van-dialog v-model="showEditDialog" :title="dialogTitle" show-cancel-button @confirm="confirmEdit"
      :confirm-button-loading="isOperating">
      <van-field v-model="editForm.enterpriseName" label="企业名称" placeholder="请输入企业名称"
        :rules="[{ required: true, message: '请输入企业名称' }]" />
      <van-field v-model="editForm.medusaUrl" label="水母地址" placeholder="请输入水母地址"
        :rules="[{ required: true, message: '请输入水母地址' }]" />
      <van-field v-model="editForm.customerPhone" label="手机号码" placeholder="请输入手机号码" />
      <van-field v-model="editForm.remark" label="备注" placeholder="请输入备注" type="textarea" />
    </van-dialog>

  </van-col>
</template>

<script>
import {
  getMyReportRecords,
  getDepartmentReportRecords,
  getAllReportRecords,
  getCreateReport,
  getUpdateReport,
} from "@/api/report";
import user from '@/utils/user'
import request from '@/utils/request'
import { Toast } from 'vant';

export default {
  enterpriseName: 'EnterpriseManage',
  data() {
    return {
      duty: -1,
      searchValue: '',
      enterpriseList: [],
      loading: false,
      finished: false,
      refreshing: false,
      showDeleteDialog: false,
      showEditDialog: false,
      dialogTitle: '',
      isAdding: false,
      editForm: {
        enterpriseName: '',
        medusaUrl: '',
        customerPhone: '',
        remark: ''
      },
      listQuery: {
        pageInfo: {
          pageSize: 10,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: true,
        employeeId: null,
        enterpriseNameLike: "",
      },
      searchTimer: null,
      // 人员筛选相关
      staffOptions: [],
      showStaffPopup: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });
  },
  props: {
    activeTab: {
      type: [Number, String],
      default: 0,
    }
  },
  computed: {
    // 计算是否正在操作中
    isOperating() {
      return this.loading || this.refreshing;
    },
    // 获取选中的人员文本
    getSelectedStaffText() {
      if (this.listQuery.employeeId === null) {
        return '请选择人员';
      }
      const selectedOption = this.staffOptions.find(option => option.id === this.listQuery.employeeId);
      return selectedOption ? selectedOption.name : '请选择人员';
    }
  },
  created() {
    this.duty = user.getUserDuty()

    // 管理员加载人员列表
    if (this.duty === 3 || this.duty === 99) {
      this.getStaffList();
    }
    this.onLoad();
  },
  beforeUnmount() {
    // 清除定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
  methods: {
    handleItem(item) {
      this.$router.push({
        path: '/credit/report',
        query: { t: this.activeTab, id: item.id }
      })

    },

    // 处理输入事件，添加防抖
    handleInput() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        this.onSearch();
      }, 500);
    },
    // 搜索企业
    onSearch() {
      this.listQuery.enterpriseNameLike = this.searchValue;
      this.onRefresh();
    },
    // 加载企业列表
    onLoad() {
      if (this.refreshing) {
        this.enterpriseList = [];
        this.listQuery.pageInfo.page = 1;
      }

      var filterForm = Object.assign({}, this.listQuery);
      if (this.duty == 1) {
        //普通员工
        getMyReportRecords(filterForm)
          .then((res) => {
            if (res.data && res.data.data) {
              const dataList = res.data.data.data || [];
              this.listQuery.pageInfo.page = res.data.data.pageInfo.page + 1;
              this.enterpriseList = this.enterpriseList.concat(dataList);
              // 根据返回数据数量判断是否还有更多数据
              this.finished = !res.data.data.pageInfo.hasMore;
            } else {
              this.finished = true;
            }
            this.loading = false;
            this.refreshing = false;
          }).catch((error) => {
            console.error('加载企业列表失败:', error);
            Toast('加载失败，请重试');
            this.loading = false;
            this.refreshing = false;
            this.finished = true;
          });
      } else if (this.duty == 2) {
        //小组长
        getDepartmentReportRecords(filterForm)
          .then((res) => {
            if (res.data && res.data.data) {
              const dataList = res.data.data.data || [];
              this.listQuery.pageInfo.page = res.data.data.pageInfo.page + 1;
              this.enterpriseList = this.enterpriseList.concat(dataList);
              // 根据返回数据数量判断是否还有更多数据
              this.finished = dataList.length < this.listQuery.pageInfo.pageSize;
            } else {
              this.finished = true;
            }
            this.loading = false;
            this.refreshing = false;
          }).catch((error) => {
            console.error('加载企业列表失败:', error);
            Toast('加载失败，请重试');
            this.loading = false;
            this.refreshing = false;
            this.finished = true;
          });
      } else if (this.duty == 3 || this.duty == 99) {
        //管理员
        getAllReportRecords(filterForm)
          .then((res) => {
            if (res.data && res.data.data) {
              const dataList = res.data.data.data || [];
              this.listQuery.pageInfo.page = res.data.data.pageInfo.page + 1;
              this.enterpriseList = this.enterpriseList.concat(dataList);
              // 根据返回数据数量判断是否还有更多数据
              this.finished = !res.data.data.pageInfo.hasMore;
            } else {
              this.finished = true;
            }
            this.loading = false;
            this.refreshing = false;
          }).catch((error) => {
            console.error('加载企业列表失败:', error);
            Toast('加载失败，请重试');
            this.loading = false;
            this.refreshing = false;
            this.finished = true;
          });
      }

    },
    // 刷新企业列表
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.refreshing = true;
      this.onLoad();
    },
    // 打开修改对话框
    onEdit(item) {
      this.isAdding = false;
      this.dialogTitle = '修改企业';
      this.editForm = Object.assign({}, item);
      this.showEditDialog = true;
    },
    // 打开添加对话框
    showAddDialogFunc() {
      this.isAdding = true;
      this.dialogTitle = '添加企业';
      this.editForm.enterpriseName = '';
      this.editForm.medusaUrl = '';
      this.editForm.customerPhone = '';
      this.editForm.remark = '';
      this.showEditDialog = true;
    },
    // 确认编辑企业（添加/修改）
    confirmEdit() {
      // 表单验证
      if (!this.editForm.enterpriseName || !this.editForm.medusaUrl) {
        Toast('请填写完整信息');
        return;
      }

      this.isOperating = true;

      // 实际请求示例：
      if (this.isAdding) {
        // 添加企业
        getCreateReport({ 
          enterpriseName: this.editForm.enterpriseName, 
          medusaUrl: this.editForm.medusaUrl, 
          customerPhone: this.editForm.customerPhone, 
          remark: this.editForm.remark 
        })
          .then(() => {
            Toast.success("添加企业成功");
            this.showEditDialog = false;
            this.isOperating = false;
            this.onRefresh();
          })
          .catch(() => {
            Toast('添加失败，请重试');
            this.isOperating = false;
          });

      } else {
        // 修改企业
        getUpdateReport(this.editForm)
          .then(() => {
            Toast.success("修改企业成功");
            this.showEditDialog = false;
            this.isOperating = false;
            this.onRefresh();
          })
          .catch(() => {
            Toast('修改失败，请重试');
            this.isOperating = false;
          });

      }
    },
    // 打开删除对话框
    onDelete(item) {
      this.currentDeleteItem = item;
      this.showDeleteDialog = true;
    },
    // 确认删除企业
    confirmDelete() {
      if (this.currentDeleteItem) {
        this.isOperating = true;
        // 模拟删除企业的请求
        setTimeout(() => {
          Toast.success("删除企业成功");
          this.showDeleteDialog = false;
          this.currentDeleteItem = null;
          this.isOperating = false;
          // 删除成功后刷新列表
          this.onRefresh();
        }, 1000);

        // 实际请求示例：
        // request.delete(`/User/Enterprise/Delete/${this.currentDeleteItem.id}`)
        //   .then(() => {
        //     Toast.success("删除企业成功");
        //     this.showDeleteDialog = false;
        //     this.currentDeleteItem = null;
        //     this.isOperating = false;
        //     this.onRefresh();
        //   })
        //   .catch(() => {
        //     Toast('删除失败，请重试');
        //     this.isOperating = false;
        //   });
      }
    },
    // 返回首页
    goToHome() {
      this.$router.push("/credit/home");
    },
    // 返回上一页
    goBack() {
      this.$router.back();
    },
    // 获取人员列表
    getStaffList() {
      request.get('/User/Department/GetStaffList')
        .then((res) => {
          if (res.data && res.data.data) {
            this.staffOptions = res.data.data;
          }
        })
        .catch((error) => {
          console.error('获取人员列表失败:', error);
        });
    },
    // 选择人员
    selectStaff(item) {
      this.listQuery.employeeId = item.id;
      this.showStaffPopup = false;
      this.onRefresh();
    },

  }
};
</script>

<style lang="less">
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.enterprise-title {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 12px;
  width: 100%;
  position: relative;
}

.search-wrapper {
  padding: 0 14px;
  background: #fff;
}

.search-wrapper.no-staff-filter {
  padding-bottom: 10px;
}

.content-wrapper {
  padding-top: 110px;
  background-color: #F0F4FF;
  min-height: calc(100vh - 110px);
}

.content-wrapper.with-staff-filter {
  padding-top: 170px;
  min-height: calc(100vh - 170px);
}

.search-wrapper .van-search {
  padding: 0;
}

.search-wrapper .van-search__content {
  background: #F5F7FF;
  padding: 3px 0;
  border: 1px solid #E3E8F5;
  border-radius: 12px;
  padding-left: 12px;
}

.search-wrapper .van-field__control {
  color: #333;
}

.search-wrapper .van-field__control::placeholder {
  color: #999;
}

.staff-search-wrapper {
  padding: 12px;
  background: #FFFFFF;
}

.staff-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #F5F7FF;
  border: 1px solid #E3E8F5;
  border-radius: 12px;
  cursor: pointer;
}

.staff-select:hover {
  border-color: #3a71ff;
  box-shadow: 0 2px 12px 0 rgba(58, 113, 255, 0.1);
}

.staff-select span {
  font-size: 0.9rem;
  color: #333;
}

.staff-popup {
  max-height: 80vh;
}

.popup-list {
  max-height: calc(80vh - 52px);
  overflow-y: auto;
}

.popup-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
}

.popup-item:last-child {
  border-bottom: none;
}

.popup-item:active {
  background: #f5f7ff;
}

.popup-item-text {
  font-size: 14px;
  color: #333;
}

.popup-empty {
  padding: 40px 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #e4e7ed;
}

.popup-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: bold;
  color: #333;
}

.popup-header .van-icon {
  cursor: pointer;
  color: #999;
}

.popup-header .van-icon:hover {
  color: #333;
}

.back-icon {
  cursor: pointer;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  margin-right: 12px;
}

.back-arrow {
  display: inline-block !important;
  width: 10px;
  height: 10px;
  border-left: 2px solid #333;
  border-bottom: 2px solid #333;
  transform: rotate(45deg);
  margin-right: 4px;
  visibility: visible !important;
  opacity: 1 !important;
}

.enterprise-text {
  position: absolute;
  left: 47.5%;
  transform: translateX(-50%);
  font-size: 18px;
  font-weight: 500;
}

.enterprise-card {
  margin: 12px 16px 0;
  padding: 16px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: box-shadow 0.3s;
}

.enterprise-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.enterprise-card-content {
  flex: 1;
  min-width: 0;
}

.enterprise-card-row {
  display: flex;
  margin-bottom: 12px;
  align-items: center;
}

.enterprise-card-row:last-child {
  margin-bottom: 0;
}

.enterprise-card-label {
  width: 80px;
  color: #666;
  font-size: 14px;
  flex-shrink: 0;
}

.enterprise-card-value {
  color: #333;
  font-size: 14px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.enterprise-card-action {
  flex-shrink: 0;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: #EDF3FA;
  border-radius: 12px;
}

.button-row {
  position: fixed;
  bottom: 20px;
  left: 16px;
  right: 16px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 999;
}

.button-row .btn-get-sub {
  flex: 1;
  margin: 0;
}

.home-button {
  width: 44px;
  height: 44px;
  background-color: #176FCA;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: background-color 0.3s;
  flex-shrink: 0;
}

.home-button:hover {
  background-color: #145EAB;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 90vh;
  justify-content: center;
  text-align: center;
}

.empty-text {
  margin-top: 16px;
  color: #999;
  font-size: 14px;
}

.btn-get-sub {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 12px;
  background: #1566C1;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

</style>